export enum ReviewStatusEnum {
  ACCEPTED = 1,
  UNDERREVIEW = 2,
  COMPLETED = 3,
  DECLINED = 4,
}
export default ReviewStatusEnum;
